export default __webpack_public_path__ + "static/media/21.24531c7c.webp";